var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61687 12.9L1.01687 10.3C0.700203 9.98331 0.62937 9.62081 0.80437 9.21248C0.97937 8.80414 1.29187 8.59998 1.74187 8.59998H6.89187C7.34187 8.59998 7.65437 8.80414 7.82937 9.21248C8.00437 9.62081 7.93354 9.98331 7.61687 10.3L5.01687 12.9C4.91687 13 4.80854 13.075 4.69187 13.125C4.5752 13.175 4.4502 13.2 4.31687 13.2C4.18354 13.2 4.05854 13.175 3.94187 13.125C3.8252 13.075 3.71687 13 3.61687 12.9Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.74187 4.6C1.29187 4.6 0.97937 4.39583 0.80437 3.9875C0.62937 3.57917 0.700203 3.21667 1.01687 2.9L3.61687 0.3C3.71687 0.2 3.8252 0.125 3.94187 0.075C4.05854 0.025 4.18354 0 4.31687 0C4.4502 0 4.5752 0.025 4.69187 0.075C4.80854 0.125 4.91687 0.2 5.01687 0.3L7.61687 2.9C7.93354 3.21667 8.00437 3.57917 7.82937 3.9875C7.65437 4.39583 7.34187 4.6 6.89187 4.6H1.74187Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.177743b0b3184d19e22262694e20a57f.svg";
export { ForwardRef as ReactComponent };